// src/components/RequireAuth.tsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiosProxyInstance } from "./utils/request";

const waitForLocalStorageValue = (key, checkInterval = 100, timeout = 5000) => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const interval = setInterval(() => {
      const value = localStorage.getItem(key);

      if (value !== null) {
        clearInterval(interval);
        resolve(value);
      } else if (Date.now() - startTime > timeout) {
        clearInterval(interval);
        reject(new Error(`Timeout: localStorage key "${key}" not found within ${timeout}ms`));
      }
    }, checkInterval);
  });
};

const RequireAuth = ({ children }) => {
    const currentENVUse = process.env.REACT_APP_CURRENT_ENV_USE;
    const navigate = useNavigate();
    const [currentUserId, setCurrentUserId] = useState("");

    const handleLogout = async () => {
        const payload = {
            uid: currentUserId,
            action: "logout"
        };
        try {
            const res = await axiosProxyInstance.post('/signout/', payload);
            if(res){
                localStorage.removeItem("LPCurrentUserId")
                localStorage.removeItem("currentCompleted");
                localStorage.removeItem("LPCurrentUserEmail");
                localStorage.removeItem("LPCurrentUserName");
                localStorage.removeItem("LPCurrentProvideruid");
                localStorage.removeItem("LPCurrentClinicId");
                localStorage.removeItem("LPCurrentClinicTitle");
                localStorage.removeItem("isOnboarding");
                // navigate('/signup')

                const url = `${process.env.REACT_APP_WP_BACKEND_URL}/login/`;
                window.location.href = url;
            }
        } catch (err) {
            console.error("Submission failed:", err);
        }
        
    };

    useEffect(() => {
        waitForLocalStorageValue("LPCurrentUserId")
        .then(userId => {
            setCurrentUserId(userId);
            // continue your logic here
        })
        .catch(err => {
            console.error(err.message);
            // handle the error or fallback
        });
    }, []);
    
    useEffect(() => {
        const isLoggedIn = document.cookie
        .split(";")
        .some((cookie) => cookie.trim().startsWith("wordpress_logged_in_user"));
        
        // document.cookie.includes("wordpress_logged_in")      

        if (!isLoggedIn && currentENVUse !== "dev" && currentUserId) {
            // localStorage.clear();
            handleLogout();
        }
    }, [navigate, currentUserId]);

    return <>{children}</>;
};

export default RequireAuth;